import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
// タブ切り替え: liクリックで対応するタブパネルだけを表示する。
// フォーム自体は1つのままで、非表示タブの入力値も送信対象として残す(表示/非表示はCSSのみ)。
export default class extends Controller {
  static targets = ["trigger", "panel"]

  select(event) {
    event.preventDefault()

    const index = this.triggerTargets.indexOf(event.currentTarget)
    this.triggerTargets.forEach((trigger, i) => trigger.classList.toggle("active", i === index))
    this.panelTargets.forEach((panel, i) => panel.classList.toggle("active", i === index))
  }
}
